const rechargeOrderStatusMap: { [key: number]: string } = {
    [-1]: '支付失败',
    0: '无需支付',
    1: '支付中',
    2: '支付成功',
}

const paymentRecordStatusMap: { [key: number]: string } = {
    [-1]: '支付失败',
    0: '支付中',
    1: '支付成功',
}

export const getRechargePaymentStatusText = (record: any) => {
    if (record.payment_status !== undefined && record.payment_status !== null) {
        return rechargeOrderStatusMap[record.payment_status] || '--'
    }

    return paymentRecordStatusMap[record.payment?.payment_status] || '--'
}

export const hasRechargeRefundOrder = (record: any) =>
    !!(
        record.refund_order &&
        (record.refund_order.id || record.refund_order.order_no || record.refund_order.refund_time)
    )

export const isRechargePaid = (record: any) =>
    record.payment_status !== undefined && record.payment_status !== null
        ? record.payment_status === 2
        : record.payment?.payment_status === 1
